import { SearchSchoolJobPostingSummary } from "@nimble/candidate-api/types";
import { Fragment } from "react";

import JobRowContainer from "@/components/shared/school/job-row.container";
import { getSchoolNoJobsMessage } from "@/components/shared/school/school-no-jobs-message";
import { schoolJobPostingsTestIds } from "@/lib/data-test-ids/schools.data-test-ids";
import { SchoolJobPostingsProps } from "@/lib/types/schools.types";

export default function SchoolJobPostings({
  schoolData,
  stateConfig,
}: SchoolJobPostingsProps) {
  const noJobsMessage = getSchoolNoJobsMessage(schoolData);

  const lastPostingIndex = schoolData.jobpostings.length - 1;

  return (
    <>
      <div
        data-testid={`${schoolJobPostingsTestIds.SCHOOL_JOB_POSTINGS}-${schoolData.nces_id}`}
      >
        {schoolData.jobpostings.length > 0 ? (
          <div
            className="space-y-1.5"
            data-testid={`${schoolJobPostingsTestIds.SCHOOL_JOB_LIST}-${schoolData.nces_id}`}
          >
            {schoolData.jobpostings.map(
              (job: SearchSchoolJobPostingSummary, index) => (
                <Fragment key={job.uuid}>
                  <JobRowContainer
                    key={job.uuid}
                    job={job}
                    schoolData={schoolData}
                    stateConfig={stateConfig}
                  />
                  {index !== lastPostingIndex && (
                    <div className="border-b border-line-faint" />
                  )}
                </Fragment>
              ),
            )}
          </div>
        ) : (
          <div
            className="flex items-center justify-center py-4"
            data-testid={`${schoolJobPostingsTestIds.SCHOOL_NO_JOBS_MESSAGE}-${schoolData.nces_id}`}
          >
            <span className="text-xs text-ink-subtle text-center font-medium">
              {noJobsMessage}
            </span>
          </div>
        )}
      </div>
    </>
  );
}
